export const ROUTE = {
  INDEX: '/',
  MY: {
    FAVORITE: '/my/favorite',
    SUBSCRIBE: '/my/subscribe',
    FAN: '/my/fan',
    HISTORY: {
      RECENT: {
        INDEX: '/my/history/recent',
        VOD: '/my/history/recent/vod',
      },
      LATER: '/my/history/later',
      UP: '/my/history/up',
      PLAYLIST: '/my/history/playlist',
      STORY: '/my/history/story',
    },
    FEED: {
      INDEX: '/my/feed',
      HOT_ISSUE: '/my/feed/hotissue',
      _USER_ID: '/my/feed/:userId',
    },
  },
  SEARCH: '/search',
  DIRECTORY: {
    CATEGORY: {
      INDEX: '/directory/category',
      _CATEGORY_MENU: '/directory/category/:categoryMenuId',
      _CATEGORY_NAME: {
        _CATEGORY_TYPE: '/directory/category/:categoryName/:categoryType',
      },
    },
  },
  LIVE: {
    ALL: '/live/all',
    GROUP: {
      _TYPE: '/live/group/:type',
    },
  },
  STAR_RANK: '/starrank',
  CHANNEL: {
    ROOT: '/station',
    BRIDGE: '/station/_/bridge',
    SERVICE: {
      HOME: '/station/:streamerId',
      BOARD: {
        BOARD_INDEX: '/station/:streamerId/board',
        BOARD_ROOT: '/station/:streamerId/board/:boardNumber',
        BOARD_TYPE: '/station/:streamerId/board/:boardNumber?',
        BOARD_WITH_OPTIONAL_NUMBER: '/station/:streamerId/board{/:boardNumber}',
      },
      POST: {
        POST_ROOT: '/station/:streamerId/post/*',
        POST_VIEW: '/station/:streamerId/post/:postNumber',
        POST_WRITE: '/station/:streamerId/post/write/:boardNumber?',
        POST_WRITE_WITH_BOARD_NUMBER:
          '/station/:streamerId/post/write/:boardNumber',
        POST_EDIT: '/station/:streamerId/post/:postNumber/edit',
      },
      VOD: {
        ALL: '/station/:streamerId/vod',
        VOD_TYPE: '/station/:streamerId/vod/:pageType',
        VOD_WITH_OPTIONAL_PAGE_TYPE: '/station/:streamerId/vod{/:pageType}',
      },
      CATCH: '/station/:streamerId/catch',
      CATCH_LEGACY: '/station/:streamerId/vods/catch', // *_LEGACY는 안드로이드에서 잘못된 Path로 배포 되었기 때문에 임시 처리를 위함. 추후 제거 요망
      CATCHSTORY: '/station/:streamerId/catchstory',
      CATCHSTORY_LEGACY: '/station/:streamerId/vods/catchstory',
      SOOPTORE: {
        ROOT: '/station/:streamerId/sooptore',
      },
      GUEST: '/station/:streamerId/guest',
      CALENDAR: '/station/:streamerId/calendar',
      INFO: '/station/:streamerId/info',
      EMPTY: '/station/:streamerId/empty',
    },
    SETTING: {
      ROOT: '/station/:streamerId/setting/*',
      INDEX: '/station/:streamerId/setting',
      MAIN: '/station/:streamerId/setting/main', // 모바일 전용 설정 메인 페이지

      // 방송국 관리
      BASIC: '/station/:streamerId/setting/basic', // 기본설정 (기본 정보) + 외부링크
      TITLE_IMAGE: '/station/:streamerId/setting/image', // 기본 설정 (이미지 설정) + 하단 배너
      HOME_SECTION: '/station/:streamerId/setting/home', // 홈 섹션 관리
      POST: '/station/:streamerId/setting/post', // 게시판 관리
      SOOP_STORE: '/station/:streamerId/setting/sooptore', // 숲토어 관리
      BAN_KEYWORD: '/station/:streamerId/setting/banword', // 금칙어 관리

      // 유저 / 권한 관리
      CHATTING_MANAGER: '/station/:streamerId/setting/chatmanager', // 매니저 관리 (채팅)
      CHANNEL_MANAGER: '/station/:streamerId/setting/channelmanager', // 매니저 관리 (방송국)
      FAN_CLUB: '/station/:streamerId/setting/fanclub', // 팬클럽 관리
      SUBSCRIBE: '/station/:streamerId/setting/subscription', // 구독팬 관리
      SUPPORTER: '/station/:streamerId/setting/supporter', // 서포터 관리
      VOD_AUTH: '/station/:streamerId/setting/vodauth', // vod 권한 추가
      VOD_DOWNLOAD_REJECT: '/station/:streamerId/setting/voddownloadlimit', // vod 다운로드 제한
      VOD_EDITOR: '/station/:streamerId/setting/vodeditor', // vod 편집각
      BLACK_LIST: '/station/:streamerId/setting/blacklist', // 블랙리스트
      CLIP_BLACKLIST: '/station/:streamerId/setting/clip-blacklist', // 클립/ catch 블랙리스트

      // 수익 및 활동내역
      // https://myrevenue.sooplive.co.kr, https://point.sooplive.co.kr/Balloon/AfreecaNormalExchange.asp?gifttype=1 두 페이지는 밖으로 분리
      SEARCH_INFO: '/station/:streamerId/setting/searchinfo', // 검색 정보 관리
      BADGE: '/station/:streamerId/setting/badge', // 배지 관리
      MEDAL: '/station/:streamerId/setting/medal', // 메달 관리

      // VOD 광고 관리
      MIDROLL: '/station/:streamerId/setting/midroll', // 중간광고 관리
    },
    /**
     * 기존 ch 도메인 당시 사용하던 경로 -> 신규 경로로 에러 없이 리디렉션 하기 위함
     * 동일 경로는 미포함
     */
    LEGACY: {
      VOD: {
        INDEX: '/station/:streamerId/vods',
        CATCH: '/station/:streamerId/vods/catch',
        CATCHSTORY: '/station/:streamerId/vods/catchstory',
        VOD_TYPE: '/station/:streamerId/vods/:pageType',
      },
      BOARD: {
        INDEX: '/station/:streamerId/posts',
        ROOT: '/station/:streamerId/posts/:boardNumber',
      },
      SOOPTORE: '/station/:streamerId/shopfreeca',
      SETTING: {
        // 방송국 관리
        POST: '/station/:streamerId/setting/board', // 게시판 관리
        SOOP_STORE: '/station/:streamerId/setting/shopfreeca', // 숲토어 관리

        // 유저 / 권한 관리
        CHATTING_MANAGER: '/station/:streamerId/setting/automanager', // 매니저 관리 (채팅)
        CHANNEL_MANAGER: '/station/:streamerId/setting/manager', // 매니저 관리 (방송국)
        VOD_DOWNLOAD_REJECT: '/station/:streamerId/setting/vodreject', // vod 다운로드 제한
        VOD_EDITOR: '/station/:streamerId/setting/editor', // vod 편집각
        BLACK_LIST: '/station/:streamerId/setting/blacklist', // 블랙리스트
        CLIP_BLACKLIST: '/station/:streamerId/setting/userclip-blacklist', // 클립/ catch 블랙리스트

        // 수익 및 활동내역
        SEARCH_INFO: '/station/:streamerId/setting/profile', // 검색 정보 관리
      },
    },
  },
  HELP: {
    ROOT: '/help/*',
    INDEX: '/help',
    // 검색 결과 페이지
    SEARCH: '/help/search',
    // 자주 묻는 질문
    FAQ: '/help/faq',
    // 자주 묻는 질문 상세 페이지
    FAQ_DETAIL: '/help/faq/:questionId',
    // 문의하기 페이지
    INQUIRY: '/help/inquiry',
    // 신고하기 - 컨텐츠 페이지
    REPORT_CONTENT: '/help/report/content',
    // 신고하기 - 불법 촬영물 페이지
    REPORT_ILLEGAL: '/help/report/illegal',
    // 신고하기 - 불법 촬영물 유형과 정의 안내 페이지
    REPORT_ILLEGAL_GUIDE: '/help/report/illegal/guide',
    // 이의신청 페이지
    OBJECTION: '/help/objection',
    // MY 문의 내역 페이지
    MY_INQUIRY: '/help/my-inquiry',
    // MY 문의 내역 상세 페이지
    MY_INQUIRY_DETAIL: '/help/my-inquiry/:inquiryId',
    // 만족도 조사 페이지
    MY_INQUIRY_SURVEY: '/help/my-inquiry/survey',
    // 챗봇 페이지
    CHATBOT: '/help/chatbot',

    // 모바일 신고하기 유형 선택 페이지
    REPORT: '/help/report',

    // 모바일 레이어
    // 자주 묻는 질문
    LAYER_FAQ: '/help/layer/faq',
    // 나의 문의 만족도 조사
    LAYER_MY_INQUIRY_SURVEY: '/help/layer/my-inquiry-survey',
  },
} as const;
